import { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import withApolloClient from '../withApolloClient'
import IncidentListHeader from './IncidentsListHeader'
import IncidentList from './IncidentsList'
import IncidentActions from "./IncidentActions"
import './Incidents.css'
import IncidentReports from './IncidentReports/IncidentReports'
import ListingTabs from '../Material/ListingTabs'


const tableHeaders = [
    { id: "id", name: "Date Added", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "data_progress", name: "Data Progress", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "title", name: "Incident Name", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "assignedTo", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "car__id", name: "Car", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "car_vin", name: "Vin", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incident_branch", name: "Incident Branch", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "dmvPlate", name: "DMV Plate", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "driver__id", name: "Driver", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "notificationDate", name: "Notification Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentDate", name: "Incident Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentTime", name: "Incident Time", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "status", name: "Status", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentType", name: "Incident Type", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "source", name: "Source", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "responsibleParty", name: "Responsible Party", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "reportedBy", name: "Reported By", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "incidentState", name: "Incident State", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "location", name: "Location", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "carOnHold", name: "Car On Hold", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "ridesharePlatform", name: "Rideshare Platform", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "ridesharePeriod", name: "Rideshare Period", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "ridesharePeriodSource", name: "Rideshare Period Source", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "carTotaled", name: "Car Totaled", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasPoliceReport", name: "Police Report?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasDashcamVideos", name: "Dashcam Videos?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasOtherParties", name: "Other Parties?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasLiabilityClaim", name: "Liability Claim?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "hasSubroClaim", name: "Subro Claim?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "isRecordOnly", name: "Is Record Only?", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]
const getDefaultColumnConfig = () => tableHeaders.map((column, index) => ({ ...column, order: index }))

const INCIDENT_LISTING_TABS = [
    { id: "#assigned", name: "Assigned Incidents", filters: { isArchived: false }, iconClassName: "fa fa-user-o" },
    { id: "#all", name: "All Incidents", filters: { isArchived: false }, iconClassName: "fa fa-list-ul" },
    { id: "#reports", name: "Reports", filters: {}, iconClassName: "fa fa-bar-chart", floatRight: true, iconOnly: true },
]

const getInitialTab = () => {
    const allowedTabs = INCIDENT_LISTING_TABS.map(item => item.id)
    return typeof window !== "undefined" && window.location.hash && allowedTabs.includes(window.location.hash)
        ? window.location.hash
        : INCIDENT_LISTING_TABS[0].id
}

class IncidentListContainer extends Component {
    constructor(props) {
        super(props)
        const initialTab = getInitialTab()
        this.state = {
            orderBy: ["-notificationDate"],
            filterValues: {},
            refetchIncidents: false,
            tab: initialTab,
            renderedTabPanes: [initialTab],
            columnConfig: getDefaultColumnConfig(),
            selectedIncidents: [],
        }
    }
    setColumnConfig = (columnConfig) => this.setState({ columnConfig })

    updateOrder = (string) => {
        let order = this.state.orderBy ? [...this.state.orderBy] : []
        let index = order.indexOf(string)
        if (index > -1) {
            order[index] = "-" + string
        } else {
            index = order.indexOf("-" + string)
            index > -1 ? order.splice(index, 1) : order.unshift(string)
        }
        this.setState({ orderBy: order })
    };

    toggleTab = (tabId) => {
        if (!this.state.renderedTabPanes.includes(tabId)) {
            this.setState({ renderedTabPanes: [...this.state.renderedTabPanes, tabId] })
        }
        const selectedTab = INCIDENT_LISTING_TABS.find(tab => tab.id === tabId)
        const defaultFilters = { ...(selectedTab?.filters || {}) }
        this.setState({
            tab: tabId,
            filterValues: defaultFilters,
            selectedIncidents: [],
        })
    }

    componentDidMount() {
        let defaultTab = INCIDENT_LISTING_TABS[0].id
        const allowedTabs = [...INCIDENT_LISTING_TABS.map(item => item.id), "#reports"]
        if (!window.location.hash || !allowedTabs.includes(window.location.hash)) {
            window.location.hash = defaultTab
            this.setState({ tab: defaultTab, renderedTabPanes: [defaultTab] })
        }
    }
    componentDidUpdate(_, prevState) {
        if (this.state.tab !== prevState.tab) {
            window.location.hash = this.state.tab
        }
    }


    render() {
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={INCIDENT_LISTING_TABS}
                    activeTab={this.state.tab}
                    onChange={this.toggleTab}
                />
                {this.state.tab !== "#reports" && <Row>
                    <Col xs={8}>
                        <IncidentListHeader
                            filterValues={this.state.filterValues}
                            setFilterValues={(filterValues) => this.setState({ filterValues, selectedIncidents: [] })}
                            defaultFilters={this.state.tab && INCIDENT_LISTING_TABS.find(tab => tab.id === this.state.tab).filters}
                            activeTab={this.state.tab}
                            {...this.props}
                        />
                    </Col>
                    <Col xs={4}>
                        <IncidentActions
                            columnConfig={this.state.columnConfig}
                            setColumnConfig={this.setColumnConfig}
                            tableId="incident"
                            defaultColumnConfig={getDefaultColumnConfig()}
                            refetchQuery={() => this.setState({ refetchIncidents: !this.state.refetchIncidents })}
                            selectedIncidents={this.state.selectedIncidents}
                            clearSelectedIncidents={() => this.setState({ selectedIncidents: [] })}
                            {...this.props}
                        />
                    </Col>
                </Row>}
                <Row>
                    <Col sm="12">
                        {this.state.tab === "#reports" ?
                            <IncidentReports />
                            :
                            <IncidentList
                                columnConfig={this.state.columnConfig}
                                key={String(this.state.refetchIncidents)}
                                currentUser={this.props.currentUser}
                                selectedIncidents={this.state.selectedIncidents}
                                setSelectedIncidents={(selectedIncidents) => this.setState({ selectedIncidents })}
                                assignedTo={this.state.filterValues.assignedTo ? this.state.filterValues.assignedTo : this.state.tab === "#assigned" ? this.props.currentUser?.id : []}
                                searchTerm={this.state.filterValues && this.state.filterValues.searchTerm ? this.state.filterValues.searchTerm : null}
                                incidentPk={this.state.filterValues && this.state.filterValues.incidentPk ? parseInt(this.state.filterValues.incidentPk) : null}
                                driverPk={this.state.filterValues && this.state.filterValues.driverPk ? parseInt(this.state.filterValues.driverPk) : null}
                                incidentTypes={this.state.filterValues && this.state.filterValues.incidentTypes ? this.state.filterValues.incidentTypes : null}
                                incidentDateIsNull={this.state.filterValues && this.state.filterValues.incidentDateIsNull !== undefined ? this.state.filterValues.incidentDateIsNull : null}
                                withoutRental={this.state.filterValues && this.state.filterValues.withoutRental !== undefined ? this.state.filterValues.withoutRental : null}
                                isArchived={this.state.filterValues && this.state.filterValues.isArchived !== undefined ? this.state.filterValues.isArchived : null}
                                statuses={this.state.filterValues && this.state.filterValues.statuses ? this.state.filterValues.statuses : null}
                                carOnHold={this.state.filterValues && this.state.filterValues.carOnHold !== undefined ? this.state.filterValues.carOnHold : null}
                                carTotaled={this.state.filterValues && this.state.filterValues.carTotaled ? this.state.filterValues.carTotaled : null}
                                sources={this.state.filterValues && this.state.filterValues.sources ? this.state.filterValues.sources : null}
                                reportedBy={this.state.filterValues && this.state.filterValues.reportedBy ? this.state.filterValues.reportedBy : null}
                                responsibleParties={this.state.filterValues && this.state.filterValues.responsibleParties ? this.state.filterValues.responsibleParties : null}
                                ridesharePlatforms={this.state.filterValues && this.state.filterValues.ridesharePlatforms ? this.state.filterValues.ridesharePlatforms : null}
                                ridesharePeriods={this.state.filterValues && this.state.filterValues.ridesharePeriods ? this.state.filterValues.ridesharePeriods : null}
                                ridesharePeriodSources={this.state.filterValues && this.state.filterValues.ridesharePeriodSources ? this.state.filterValues.ridesharePeriodSources : null}
                                externalIdKeys={this.state.filterValues && this.state.filterValues.externalIdKeys ? this.state.filterValues.externalIdKeys : null}
                                hasLiabilityClaim={this.state.filterValues && this.state.filterValues.hasLiabilityClaim !== undefined ? this.state.filterValues.hasLiabilityClaim : null}
                                hasSubroClaim={this.state.filterValues && this.state.filterValues.hasSubroClaim !== undefined ? this.state.filterValues.hasSubroClaim : null}
                                liabilityClaimExists={this.state.filterValues && this.state.filterValues.liabilityClaimExists !== undefined ? this.state.filterValues.liabilityClaimExists : null}
                                subroClaimExists={this.state.filterValues && this.state.filterValues.subroClaimExists !== undefined ? this.state.filterValues.subroClaimExists : null}
                                incidentBranchIds={this.state.filterValues?.incidentBranchIds ? this.state.filterValues.incidentBranchIds : null}
                                lineOfBusinessIds={this.state.filterValues?.lineOfBusinessIds ? this.state.filterValues.lineOfBusinessIds : null}
                                incidentDateGte={this.state.filterValues?.incidentDate?.start ? this.state.filterValues.incidentDate.start : null}
                                incidentDateLte={this.state.filterValues?.incidentDate?.end ? this.state.filterValues.incidentDate.end : null}
                                orderBy={this.state.orderBy}
                                activeDrivers={this.state.filterValues?.activeDrivers !== undefined ? this.state.filterValues.activeDrivers : null}
                                hasIncompleteReturn={this.state.filterValues?.hasIncompleteReturn !== undefined ? this.state.filterValues.hasIncompleteReturn : null}
                                hasUnauthorizedDrivers={this.state.filterValues?.hasUnauthorizedDrivers !== undefined ? this.state.filterValues.hasUnauthorizedDrivers : null}
                                updateOrder={this.updateOrder}
                                dateAddedGte={this.state.filterValues?.dateAdded?.start ? this.state.filterValues.dateAdded.start : null}
                                dateAddedLte={this.state.filterValues?.dateAdded?.end ? this.state.filterValues.dateAdded.end : null}
                            />}
                    </Col>
                </Row>
            </Container>
        )
    }
}



export default withApolloClient(
    IncidentListContainer
)
